// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({535: "lib-router",783: "lib-react",}[chunkId] || chunkId) + "." + {10: "13920a5840",157: "8a523a6e84",292: "9963b070f8",342: "a35f673430",362: "9e836edcd6",531: "86be04fef6",535: "ce9598017c",556: "64f5213fe2",588: "d91aae150e",694: "5e246c3fee",741: "aaad674407",783: "797dcb5662",904: "f03539c717",945: "298959f0e6",951: "a33cb4c150",}[chunkId] + ".js"
}